<template>
  <div style="display: flex; justify-content: space-between">
    <GeneralItem
      title="Frais réel"
      :tval="general.tot_exp.tval"
      :prct="general.tot_exp.prct"
      :arrow="general.tot_exp.arrow"
      :moneyFormat="true"
    />

    <!-- <GeneralItem
      title="Nombre de sinistre"
      subTitle=""
      :tval="general.tot_sin.tval"
      :prct="general.tot_sin.prct"
      :arrow="general.tot_sin.arrow"
      :numberFormat="true"
    /> -->

    <GeneralItem
      title="Remboursement CPMS"
      subTitle=""
      :tval="general.rb.tval"
      :prct="general.rb.prct"
      :arrow="general.rb.arrow"
      :moneyFormat="true"
    />

    <GeneralItem
      title="Remboursement moyen"
      subTitle="Par assuré"
      :tval="general.average_rb.tval"
      :prct="general.average_rb.prct"
      :arrow="general.average_rb.arrow"
      :moneyFormat="true"
    />

    <GeneralItem v-if="general.average_remains != null"
      title="Reste à charge moyen"
      subTitle="Par assuré"
      :tval="general.average_remains.tval"
      :prct="general.average_remains.prct"
      :arrow="general.average_remains.arrow"
      :moneyFormat="true"
    />
  </div>
</template>

<script>
import GeneralItem from "./GeneralItem.vue";

export default {
  components: {
    GeneralItem,
  },
  props: {
    general: {
      type: Object,
      required: true,
    },
  },
};
</script>